import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'dispatch-search',
    templateUrl: './dispatch-search.component.html',
    styleUrls: ['./dispatch-search.component.scss'],
    standalone: false
})
export class DispatchSearchComponent implements OnInit {

  constructor()
  {
  }

  ngOnInit() {
  }

}
